import React from 'react';

import {Container} from './GamesGrid.styles';
import styled from 'styled-components';

import ContentBox from '../ContentBox';
import {useTranslation} from 'react-i18next';
import {notWebMediaQuery} from '../../styles';
import GameItem from '../DKidsGames/GameItem';

function GamesGrid({
    items,
    featured,
    hidePlayButton,
    onClickItem,
    infinite,
    previewAmount,
    activeSlide,
    className,
    brand,
}) {
    if (featured) {
        return (
            <Container id="games-grid">
                {[...items, ...items, ...items].map((item, index) => {
                    return (
                        <FeaturedGameItem
                            key={index}
                            game={item}
                            index={index}
                            onClickItem={onClickItem}
                            isActive={activeSlide === index % items.length}
                            isNext={
                                (activeSlide + items.length + 1) %
                                    items.length ===
                                index % items.length
                            }
                            isPrev={
                                (activeSlide + items.length - 1) %
                                    items.length ===
                                index % items.length
                            }
                        />
                    );
                })}
            </Container>
        );
    }

    return (
        <Container id="games-grid" className={className}>
            {infinite &&
                [...items, ...items]
                    .slice(-previewAmount)
                    .map((item, index) => {
                        return (
                            <ContentBox
                                key={`infinite_prev_${item.id}_${index}`}
                                id={item.id}
                                data={item}
                                featured={featured}
                                hideFavouriteButton
                                hidePlayButton
                                background={item.image}
                                title={item.showName}
                                sub={item.title}
                                type="game"
                                action={() => onClickItem(item.id, item)}
                            />
                        );
                    })}
            {items.map((item, index) => {
                if (brand === 'dkids') {
                    return (
                        <GameItem
                            key={item.id}
                            game={item}
                            onClick={() => onClickItem(item.id, item)}
                            showIcon={true}
                            showTitle
                        />
                    );
                }
                return (
                    <ContentBox
                        key={item.id}
                        id={item.id}
                        data={item}
                        featured={featured}
                        hideFavouriteButton
                        hidePlayButton={hidePlayButton}
                        background={item.image}
                        title={item.title}
                        sub={item.showName}
                        type="game"
                        action={() => onClickItem(item.id, item)}
                    />
                );
            })}
            {infinite &&
                [...items, ...items]
                    .slice(0, previewAmount)
                    .map((item, index) => {
                        return (
                            <ContentBox
                                key={`infinite_after_${item.id}_${index}`}
                                id={item.id}
                                data={item}
                                featured={featured}
                                hideFavouriteButton
                                hidePlayButton
                                background={item.image}
                                title={item.showName}
                                sub={item.title}
                                type="game"
                                action={() => onClickItem(item.id, item)}
                            />
                        );
                    })}
        </Container>
    );
}

export default GamesGrid;

const FeaturedGameItem = props => {
    const {t} = useTranslation();

    const _onClick = () => {
        props.onClickItem(props.game.id, props.game);
    };

    return (
        <FeaturedContainer game={props.game} {...props} onClick={_onClick}>
            <Content>
                <Background />

                <Title>{props.game.title}</Title>
                <Subtitle>{props.game.showName}</Subtitle>
                <ButtonPlay>{t('games.playCTA')}</ButtonPlay>
            </Content>
        </FeaturedContainer>
    );
};

const FeaturedContainer = styled.div`
    background-image: url(${props => props.game.image});
    display: flex;
    width: 100%;
    aspect-ratio: 16/9;
    background-size: cover;
    ${props => props.isActive && `transform: scale(1.0);`}
    ${props =>
        props.isNext &&
        `transform: scale(0.95) translateX(-16px); opacity: 0.5;`}
    ${props =>
        props.isPrev &&
        `transform: scale(0.95) translateX(16px); opacity: 0.5;`}
    transition: transform 0.5s ease;
`;

const Content = styled.div`
    position: absolute;
    display: flex;
    width: 100%;
    flex-direction: column;
    bottom: 0px;
    aspect-ratio: 16/9;
    justify-content: flex-end;
    opacity: 0;
    cursor: pointer;
    transition: 0.3s;

    &:hover,
    &:active {
        opacity: 1;
    }

    ${notWebMediaQuery} {
        display: none;
    }
`;
const Title = styled.div`
    font-family: TTNormsProExtraBlack;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    text-transform: uppercase;
    padding-left: 24px;
    z-index: 2;
`;

const Subtitle = styled.div`
    font-family: AvenirNextRoundedStd;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    padding: 0px 0px 11px 24px;
    z-index: 2;
`;

const Background = styled.div`
    position: absolute;
    width: 100%;
    height: 114px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 56.56%);
    opacity: 0.75;
`;

const ButtonPlay = styled.div`
    font-family: TTNormsProExtraBlack;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
    color: white;
    padding: 8px 15px;
    background: rgba(255, 255, 255, 0.18);
    border-radius: 16px;
    overflow: hidden;
    text-transform: uppercase;
    margin-right: 15px;
    position: absolute;
    bottom: 20px;
    right: 23px;
`;
